import { render, staticRenderFns } from "./AIChatLog.vue?vue&type=template&id=2e708134&"
import script from "./AIChatLog.vue?vue&type=script&lang=js&"
export * from "./AIChatLog.vue?vue&type=script&lang=js&"
import style0 from "./AIChatLog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports